export const LOCALE_STORAGE_KEY = 'ych-yoyo-locale';

export const SUPPORTED_LOCALES = [
  { code: 'en', label: 'English', shortLabel: 'EN', ogLocale: 'en_US' },
  { code: 'ja', label: '日本語', shortLabel: '日本語', ogLocale: 'ja_JP' },
  { code: 'zh-CN', label: '简体中文', shortLabel: '简中', ogLocale: 'zh_CN' },
  { code: 'zh-TW', label: '繁體中文', shortLabel: '繁中', ogLocale: 'zh_TW' },
  { code: 'fr', label: 'Français', shortLabel: 'FR', ogLocale: 'fr_FR' },
  { code: 'es', label: 'Español', shortLabel: 'ES', ogLocale: 'es_ES' },
  { code: 'ko', label: '한국어', shortLabel: '한국어', ogLocale: 'ko_KR' },
];

const localeCodes = new Set(SUPPORTED_LOCALES.map(({ code }) => code));

const getBrowserNavigator = () => (typeof window === 'undefined' ? undefined : window.navigator);
const getBrowserStorage = () => {
  try {
    return typeof window === 'undefined' ? undefined : window.localStorage;
  } catch {
    return undefined;
  }
};

export const isSupportedLocale = (locale) => localeCodes.has(locale);

export const normalizeBrowserLocale = (locale) => {
  if (typeof locale !== 'string' || !locale.trim()) return null;

  const normalized = locale.trim().replace(/_/g, '-').toLowerCase();
  if (normalized === 'zh-tw' || normalized === 'zh-cn') {
    return normalized === 'zh-tw' ? 'zh-TW' : 'zh-CN';
  }
  if (/^zh-(tw|hk|mo|hant)(-|$)/.test(normalized)) return 'zh-TW';
  if (normalized === 'zh' || /^zh-/.test(normalized)) return 'zh-CN';
  if (/^ja(-|$)/.test(normalized)) return 'ja';
  if (/^fr(-|$)/.test(normalized)) return 'fr';
  if (/^es(-|$)/.test(normalized)) return 'es';
  if (/^ko(-|$)/.test(normalized)) return 'ko';
  if (/^en(-|$)/.test(normalized)) return 'en';
  return null;
};

export const detectBrowserLocale = (browserNavigator = getBrowserNavigator()) => {
  if (!browserNavigator) return 'en';

  const candidates = browserNavigator.languages?.length
    ? Array.from(browserNavigator.languages)
    : [browserNavigator.language];

  for (const candidate of candidates) {
    const locale = normalizeBrowserLocale(candidate);
    if (locale) return locale;
  }
  return 'en';
};

export const getInitialLocale = ({
  storage = getBrowserStorage(),
  browserNavigator = getBrowserNavigator(),
} = {}) => {
  try {
    const storedLocale = storage?.getItem(LOCALE_STORAGE_KEY);
    if (isSupportedLocale(storedLocale)) return storedLocale;
  } catch {
    // Privacy settings can make localStorage unavailable; browser detection still works.
  }
  return detectBrowserLocale(browserNavigator);
};

export const getLocaleDefinition = (locale) =>
  SUPPORTED_LOCALES.find(({ code }) => code === locale) || SUPPORTED_LOCALES[0];
